import classNames from 'classnames';
import { ReactNode } from 'react';
import { createUseStyles } from 'react-jss';

import { Theme } from '@app/theme';
import { CriterionStatusEnum } from '@app/api';

interface Props {
  criterionStatus?: CriterionStatusEnum;
  text?: string;
  children?: ReactNode;
  className?: string;
}

const useStyles = createUseStyles((theme: Theme) => ({
  qualifyingCell: {
    color: theme.colors.greenAccessible,
  },
  disQualifyingCell: {
    color: theme.colors.redAccessible,
  },
  outOfQuotaCell: {
    color: theme.colors.yellowAccessible,
  },
  icon: {
    fontSize: theme.iconSize.small,
    marginRight: theme.marginBase / 2,
  },
}));

export const CriterionStatusText = ({
  criterionStatus: status,
  text,
  children,
  className,
}: Props) => {
  const classes = useStyles();

  return (
    <div
      className={classNames(className, {
        [classes.qualifyingCell]: status === CriterionStatusEnum.QUALIFY,
        [classes.disQualifyingCell]: status === CriterionStatusEnum.DISQUALIFY,
        [classes.outOfQuotaCell]: status === CriterionStatusEnum.OUT_OF_QUOTA,
      })}
    >
      {status === CriterionStatusEnum.QUALIFY && (
        <i className={classNames(classes.icon, 'ri-checkbox-circle-fill')} />
      )}
      {status === CriterionStatusEnum.DISQUALIFY && (
        <i className={classNames(classes.icon, 'ri-close-circle-fill')} />
      )}
      {status === CriterionStatusEnum.OUT_OF_QUOTA && (
        <i className={classNames(classes.icon, 'ri-pie-chart-line')} />
      )}
      {text || children}
    </div>
  );
};
